import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {LangService} from '../../../core/services/lang.service';
import {environment} from '../../../../environments/environment';

interface LanguageOption {
  code: string;
  label: string;
}

@Component({
  selector: 'lang-selector',
  templateUrl: './lang-selector.component.html',
  styleUrls: ['./lang-selector.component.scss'],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class LangSelectorComponent {

  currentLang = environment.defaultAppLang;

  languages: LanguageOption[] = [
    {code: 'es', label: 'Español'},
    {code: 'en', label: 'English'},
    {code: 'fr', label: 'Français'},
    {code: 'de', label: 'Deutsch'},
    {code: 'it', label: 'Italiano'},
    {code: 'pt', label: 'Português'},
  ];

  isOpen = false;
  selected: LanguageOption = this.languages.find(l => l.code === environment.defaultAppLang) || this.languages[0];

  constructor(private langService: LangService) {
    const saved = langService.currentLang();
    if (saved) {
      this.currentLang = saved;
      this.selected = this.languages.find(l => l.code === saved) || this.selected;
    }
  }

  toggleDropdown(): void {
    this.isOpen = !this.isOpen;
  }

  selectLanguage(lang: LanguageOption): void {
    this.langService.setCurrentLang(lang.code);
    this.onWeglotReady(() => {
      (window as any).Weglot.switchTo(lang.code);
    });
    this.selected = lang;
    this.isOpen = false;
  }

  close(): void {
    this.isOpen = false;
  }

  private onWeglotReady(callback: () => void) {
    const interval = setInterval(() => {
      const w = (window as any).Weglot;
      if (w && w.initialized) {
        clearInterval(interval);
        callback();
      }
    }, 100);
  }
}
